import React, { useState, ReactNode, useEffect, useMemo } from "react";

import AccountTreeIcon from "@material-ui/icons/AccountTree";
import BookIcon from "@material-ui/icons/Book";
import BusinessIcon from "@material-ui/icons/Business";
import CategoryIcon from "@material-ui/icons/Category";
import ContactsIcon from "@material-ui/icons/Contacts";
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";
import PeopleIcon from "@material-ui/icons/People";
import RateReviewIcon from "@material-ui/icons/RateReview";
import ReceiptIcon from "@material-ui/icons/Receipt";
import SystemUpdateIcon from "@material-ui/icons/SystemUpdate";
import ThumbsUpDownIcon from "@material-ui/icons/ThumbsUpDown";

import { useUserState } from "../context";

export interface ApplicationMenuEntry {
  icon: ReactNode;
  label: string;
  route: string;
  roles: string[];
}

const applicationMenuEntries: ApplicationMenuEntry[] = [
  {
    icon: <SystemUpdateIcon />,
    label: "Versioni applicazione",
    route: "/app/app-versions",
    roles: ["system_admin"],
  },
  {
    icon: <PeopleIcon />,
    label: "Utenti (condomini)",
    route: "/app/users",
    roles: ["system_admin", "building_manager", "concierge"],
  },
  {
    icon: <BusinessIcon />,
    label: "Palazzi",
    route: "/app/buildings",
    roles: ["system_admin", "building_manager"],
  },
  {
    icon: <MeetingRoomIcon />,
    label: "Appartamenti",
    route: "/app/apartments",
    roles: ["system_admin", "concierge", "building_manager"],
  },
  {
    icon: <ThumbsUpDownIcon />,
    label: "CSI",
    route: "/app/csi",
    roles: ["system_admin"],
  },
  {
    icon: <BookIcon />,
    label: "Prenotazioni",
    route: "/app/reservations",
    roles: ["system_admin", "concierge", "building_manager"],
  },
  {
    icon: <AccountTreeIcon />,
    label: "Gruppi Comunicazioni",
    route: "/app/communication_groups",
    roles: ["system_admin", "concierge", "building_manager"],
  },
  {
    icon: <RateReviewIcon />,
    label: "Comunicazioni",
    route: "/app/communications",
    roles: ["system_admin", "concierge", "building_manager"],
  },
  {
    icon: <CategoryIcon />,
    label: "Servizi",
    route: "/app/amenities",
    roles: ["system_admin", "concierge", "building_manager"],
  },
  {
    icon: <CategoryIcon />,
    label: "Operatività Servizi",
    route: "/app/amenities_definitions",
    roles: ["system_admin", "concierge", "building_manager"],
  },
  {
    icon: <CategoryIcon />,
    label: "Servizi esterni",
    route: "/app/services",
    roles: ["system_admin", "concierge", "building_manager"],
  },
  {
    icon: <BookIcon />,
    label: "Prenotazioni S.E.",
    route: "/app/service_reservations",
    roles: ["system_admin", "concierge"],
  },
  {
    icon: <CategoryIcon />,
    label: "Servizi",
    route: "/app/services",
    roles: ["system_admin", "service_provider"],
  },
  {
    icon: <ContactsIcon />,
    label: "Numeri utili",
    route: "/app/contacts",
    roles: ["system_admin", "concierge", "building_manager"],
  },
  {
    icon: <ReceiptIcon />,
    label: "Coupons",
    route: "/app/coupons",
    roles: ["system_admin", "concierge", "building_manager"],
  },
];

function useApplicationMenu() {
  const { userRole, applicationMenuServiceRoutes } = useUserState();
  const [applicationMenuItems, setApplicationMenuItems] = useState(
    [] as ApplicationMenuEntry[]
  );

  useEffect(() => {
    if (userRole) {
      setApplicationMenuItems(
        applicationMenuEntries.filter((item) => item.roles.includes(userRole))
      );
    }
  }, [userRole]);

  const computedApplicationMenuItems = useMemo(() => {
    return [
      ...(applicationMenuItems ?? []),
      ...(applicationMenuServiceRoutes ?? []),
    ];
  }, [applicationMenuItems, applicationMenuServiceRoutes]);

  return {
    applicationMenuItems: computedApplicationMenuItems,
  };
}

export { useApplicationMenu };
